import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {UserInfo} from './../models/user-info';
import {IRegistrationRepository} from './../repositories/registration.repository.interface';

@Injectable()
export class RegistrationService {

  constructor(@Inject('IRegistrationRepository') private registrationRepository: IRegistrationRepository) { }

  public register(data: UserInfo): Observable<string> {
    return this.registrationRepository.register(data);
  }

  public isValid(voucherCode: string): Observable<boolean> {
    return this.registrationRepository.isValid(voucherCode);
  }

}
